import BpkButton, {
  BUTTON_TYPES,
} from '@skyscanner-internal/backpack-web/bpk-component-button';
import BpkLargeExclamationCircleIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/exclamation-circle';
import {
  BpkBox,
  BpkFlex,
  BpkSpacing,
} from '@skyscanner-internal/backpack-web/bpk-component-layout';
import BpkPanel from '@skyscanner-internal/backpack-web/bpk-component-panel';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import { statusDangerSpotDay } from '@skyscanner/bpk-foundations-web/tokens/base.es6';

import STYLES from './FlightListStatus.module.scss';

interface FlightListStatusProps {
  buttonText?: string;
  message: string;
  onButtonClick?: () => void;
  error?: boolean;
}

const FlightListStatus = ({
  buttonText = undefined,
  error = false,
  message,
  onButtonClick = undefined,
}: FlightListStatusProps) => (
  <BpkBox marginBottom={BpkSpacing.LG}>
    {/* className kept only for the 4px border-radius: BpkPanel/BpkBox expose no radius prop */}
    <BpkPanel keyline={false} className={STYLES.FlightListStatus}>
      <BpkFlex direction="column" justify="center" align="center">
        <BpkFlex
          data-testid="flight-list-status-icon-container"
          align="center"
          height="2.25rem"
          marginTop={BpkSpacing.MD}
          marginBottom={BpkSpacing.MD}
        >
          <BpkLargeExclamationCircleIcon
            fill={error ? statusDangerSpotDay : undefined}
          />
        </BpkFlex>
        <BpkText tagName="p" textStyle={TEXT_STYLES.label1} textAlign="center">
          {message}
        </BpkText>
        {buttonText && (
          <BpkBox marginTop={BpkSpacing.MD}>
            <BpkButton onClick={onButtonClick} type={BUTTON_TYPES.secondary}>
              {buttonText}
            </BpkButton>
          </BpkBox>
        )}
      </BpkFlex>
    </BpkPanel>
  </BpkBox>
);

export default FlightListStatus;
